import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, loadScrollMagic, mobileIs } from "../../utils/siteUtils";
import { BackgroundImage, PrimaryButton, IconLink } from "../../elements";
import gsap from 'gsap';
import "./style.scss";
const Emotive = props => {
  const { lang, rendering, fields, page } = props;
  const { title, description, pcImage, mobileImage, icon, link } = fields;
  const isAR = page?.fields?.rtl?.value;
  const isMobile = mobileIs()
  const image = isMobile ? mobileImage : pcImage;
  const imageNode = useRef()
  const rootNode = useRef()
  const iconLinkProp = {
    iconName: icon,
    link: link,
  };

  const onScroll = () => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth;
    let nodeTop = rootNode.current.getBoundingClientRect().top;
    let nodeWidth = rootNode.current.getBoundingClientRect().width;
    if (!isMobile) {
      if (nodeTop < pageHeight && nodeTop > 0) {
        let progress = 1 - nodeTop / pageHeight;
        imageNode.current.style.width = pageWidth - (pageWidth - pageHeight) * progress + 'px';
      }
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [])

  const rootClasses = classNames("c-emotive", isAR ? 'rtl' : '', getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
      <BackgroundImage {...image} className="c-emotive__mobile">
        <div className="c-emotive__mobile__link">
          <IconLink {...iconLinkProp} />
        </div>
        <RichText className={'c-emotive__mobile__description'} tag="div" field={description} />
      </BackgroundImage>
      <div className="c-emotive__pc">
        <div className="c-emotive__pc__left">
          <div className="c-emotive__pc__left__text">
            <RichText className={'c-emotive__pc__left__text__title'} tag="div" field={title} />
            <RichText className={'c-emotive__pc__left__text__description'} tag="div" field={description} />
          </div>
        </div>
        <div className="c-emotive__pc__imageCon" ref={imageNode}>
          <BackgroundImage {...image} className="c-emotive__pc__image">
            <div className="c-emotive__pc__image__link">
              <IconLink {...iconLinkProp} />
            </div>
          </BackgroundImage>
        </div>
      </div>
    </div>
  );
};

export default Emotive;